<ng-container *ngIf="documentType !== 'BLRDOC'">
	<div *ngIf="titleText" [class.document-grid]="isDocumentGrid">
		<ng-container [ngSwitch]="isSender">
			<ng-container *ngSwitchCase="true">
				<ng-container *ngIf="!isReadByPartner; then checked; else readByPartner">
				</ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="false">
				<ng-container *ngIf="isRead; else notRead">
					<ng-container *ngIf="!errorMessage">
						<img src="static/icons/Incoming.svg" title="{{ titleText }}"/>
					</ng-container>
					<ng-container *ngIf="errorMessage">
						<img src="static/icons/IncomingError.svg" title="{{ errorLabel?.inError }}: {{ errorMessage }}" class="incoming-error"/>
					</ng-container>
				</ng-container>
			</ng-container>
		</ng-container>
	</div>
</ng-container>

<ng-template #notRead>
	<ng-container *ngIf="!isLoading">
		<ng-container *ngIf="!errorMessage">
			<img src="static/icons/NotRead.svg" title="{{ titleText }}"/>
		</ng-container>
		<ng-container *ngIf="errorMessage">
			<img src="static/icons/NotReadError.svg" title="{{ titleText }}" class="outgoing-error"/>
		</ng-container>
	</ng-container>
</ng-template>

<ng-template #checked>
	<ng-container *ngIf="!errorMessage">
		<img src="static/icons/Checked.svg" title="{{ titleText }}"/>
	</ng-container>
	<ng-container *ngIf="errorMessage">
		<img src="{{ documentType === 'ROSEU' ? 'static/icons/OutgoingError2.svg' : 'static/icons/OutgoingError.svg' }}" title="{{ errorLabel?.outError }}: {{ errorMessage }}" class="outgoing-error"/>
	</ng-container>
</ng-template>

<ng-template #readByPartner>
	<ng-container *ngIf="!isRead; else checked">
		<img src="static/icons/ReadByPartner.svg" title="{{ titleText }}"/>
	</ng-container>
</ng-template>

<div *ngIf="titleText || isLoading" [class.document-grid]="isDocumentGrid">
	<ng-container *ngIf="isLoading">
		<img class="loading" src="static/icons/Loading.svg" title="{{ titleText }}"/>
	</ng-container>
</div>

<div *ngIf="isNewVersionDoc">
	<img class="loading" src="static/icons/Version.svg"/>
</div>

<ng-container *ngIf="documentType === 'BLRDOC'">
	<div *ngIf="titleText" [class.document-grid]="isDocumentGrid">
		<ng-container [ngSwitch]="isSender">
			<ng-container *ngSwitchCase="true">
				<ng-container *ngIf="isReadByPartner && isRead; else isNotReadByPartner">
					<ng-container *ngIf="!errorMessage; else error">
						<img src="static/icons/blrdoc/OutgoingRead.svg" title="{{ titleText }}"/>
					</ng-container>
				</ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="false">
				<ng-container *ngIf="isReadByPartner && isRead; else isNotReadIncomingByPartner">
					<img src="static/icons/blrdoc/IncomingRead.svg" title="{{ titleText }}"/>
				</ng-container>
			</ng-container>
		</ng-container>
	</div>
	<ng-template #error>
		<img src="static/icons/blrdoc/OutgoingError.svg" title="{{ errorLabel?.outError }}: {{ errorMessage }}" class="outgoing-error"/>
	</ng-template>
	<ng-template #isNotReadByPartner>
		<img src="static/icons/blrdoc/OutgoingNotRead.svg" title="{{ titleText }}"/>
	</ng-template>
	<ng-template #isNotReadIncomingByPartner>
		<img src="static/icons/blrdoc/IncomingNotRead.svg" title="{{ titleText }}"/>
	</ng-template>
</ng-container>

<ng-container *ngIf="isEditable">
	<div>
		<ng-container>
			<img src="static/icons/EditDocument.svg"/>
		</ng-container>
	</div>
</ng-container>

<ng-container *ngIf="isMarkRead">
	<div class="mark">
		<ng-container>
			<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#828fad">
				<path d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h404q-4 20-4 40t4 40H160l320 200 146-91q14 13 30.5 22.5T691-572L480-440 160-640v400h640v-324q23-5 43-14t37-22v360q0 33-23.5 56.5T800-160H160Zm0-560v480-480Zm515 45q-35-35-35-85t35-85q35-35 85-35t85 35q35 35 35 85t-35 85q-35 35-85 35t-85-35Z"/>
			</svg>
		</ng-container>
	</div>
</ng-container>
